import { getLink } from "../../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Ĉagreniĝis mi sufiĉe, <br/>
        Ke hazardo malfeliĉe <br/>
        Povas trafi nin. <br/>
        Dume ni ploradis triste, <br/>
        Petis pri la sav’ insiste, <br/>
        Ravis nin fascin’.
      </p>

      <p class="poem-block mb-3">
        Jen printempo en la vero <br/>
        Kun promeso de somero, <br/>
        Estu ĝi la ĝoj’. <br/>
        La odor’ de pan’, mielo, <br/>
        La plej rava sub ĉielo <br/>
        Ĝi – komenc’ de ĉiu voj’.
      </p>

      <p class="poem-block mb-3">
        Sonu kanto ĝojgratula <br/>
        Pri l’ printempo bluokula <br/>
        Kaj la suna tag’. <br/>
        Ploru neĝo en degelo, <br/>
        Lasu vintron en malhelo, <br/>
        Lasu nin, ĉiu plag’!
      </p>

      <p class="poem-block mb-3">
        Baldaŭ krevos la burĝonoj <br/>
        Kaj aperos verdaj tonoj <br/>
        En tenera glu’. <br/>
        Milda fajro de la branĉoj <br/>
        Kaj elastaj ŝosolancoj – <br/>
        Do, ni vivos plu!
      </p>

      <p class="poem-block mb-3">
        Do salutu ni printempon, <br/>
        La frenezan belan tempon, <br/>
        Regu ĉie rid’! <br/>
        Pasis vintro kun la ploroj, <br/>
        Nun aperu ĉie floroj, <br/>
        Venu la lucid’!
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Printempo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['yOLzMvjd_u0'],
    itemTranslator: translator.esp
  }
}

export default item;